import produce from 'immer'
import Actions from '../actions'
import { clinicTypes, routes } from '../consts'

const initialState = {
  familyList: [],
  isFamilyListLoading: false,
  isTechnicalIssues: false,
  selectedService: null,
  isHTNFollowUp: false,
  isMHFollowUp: false,
  isDMFollowUp: false,
  isPrimaryHMOFollowUp: false,
  blockEarliest: false,
  isTimeWindowLoading: false,
  shouldDisplayTerminateBotAlert: false,
  navigateFromBot: routes.ROOT,
  shouldDisplayTerminateRiskAssessmentAlert: false,
  isConnectivityTesting: false,
  isRescheduleFlow: false,
  promptClinic: null,
  isConnectivityTested: false,
  isPCPFlow: null,
  isCompleteRiskAssessmentDialogVisible: false,
  hmoSelectedIntent: [],
  isAfterConcent: false,
  isRescheduleLoading: false
}

// Keep it separate so we can support getting this data from elsewhere in the future
export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.BOT_CONCENT_STATUS_CHANGED: {
      draft.isAfterConcent = payload
      break
    }
    case Actions.SHOW_FAMILY_MEMBERS_REQUESTED: {
      draft.isFamilyListLoading = true
      break
    }
    case Actions.SHOW_FAMILY_MEMBERS_RECEIVED: {
      draft.familyList = payload?.members
      draft.isFamilyListLoading = false
      break
    }
    case Actions.APPOINTMENTS_POLL_RECEIVED:
    case Actions.BLOCK_EARLIEST_STATUS_RECEIVED: {
      const { block_earliest } = payload
      draft.blockEarliest = block_earliest
      break
    }
    case Actions.SHOW_MORE_TIME_OPTIONS_ERROR: {
      draft.isTimeWindowLoading = false
      draft.isTechnicalIssues = true
      break
    }
    case Actions.HTN_BOT_STARTED: {
      draft.selectedService = clinicTypes.HTN
      break
    }
    case Actions.DIABETES_BOT_STARTED: {
      draft.selectedService = clinicTypes.DIABETES
      break
    }
    case Actions.MENTALHEALTH_BOT_STARTED: {
      draft.selectedService = clinicTypes.MENTAL
      break
    }
    case Actions.OPEN_MH_FOLLOW_UP_BOT_SCREEN: {
      draft.isMHFollowUp = true
      draft.selectedService = clinicTypes.MENTAL
      break
    }
    case Actions.OPEN_HTN_FOLLOW_UP_BOT_SCREEN: {
      draft.isHTNFollowUp = true
      draft.selectedService = clinicTypes.HTN
      break
    }
    case Actions.OPEN_DM_FOLLOW_UP_BOT_SCREEN: {
      draft.isDMFollowUp = true
      draft.selectedService = clinicTypes.DIABETES
      break
    }
    case Actions.OPEN_PRIMARY_HMO_FOLLOW_UP_BOT_SCREEN: {
      draft.selectedService = clinicTypes.PRIMARY
      draft.isPrimaryHMOFollowUp = true
      draft.hmoSelectedIntent = payload?.intent
      break
    }
    case Actions.RESCHEDULE_APPOINTMENT_REQUESTED: {
      const { clinic } = payload
      draft.selectedService = clinic
      draft.isRescheduleLoading = true
      draft.isRescheduleFlow = true
      break
    }
    case Actions.RESCHEDULE_APPOINTMENT_RECEIVED: {
      draft.isRescheduleLoading = false
      break
    }
    case Actions.PRIMARY_CLINIC_CLICKED: {
      draft.selectedService = clinicTypes.PRIMARY
      break
    }
    case Actions.APPOINTMENT_TIMEWINDOWS_REQUESTED: {
      draft.isTimeWindowLoading = true
      break
    }
    case Actions.APPOINTMENT_TIME_SELECTED: {
      draft.isTimeWindowLoading = true
      break
    }
    case Actions.APPOINTMENT_TIMEWINDOWS_RECEIVED: {
      draft.isTimeWindowLoading = false
      break
    }
    case Actions.APPOINTMENT_DESIGNATED_TIMEWINDOWS_RECEIVED: {
      draft.isTimeWindowLoading = false
      break
    }
    case Actions.PAYMENT_FLOW_TRIGGERED:
    case Actions.OPERATION_FAILED: {
      draft.isTimeWindowLoading = false
      break
    }
    case Actions.TERMINATE_BOT_POPUP: {
      draft.shouldDisplayTerminateBotAlert = payload?.isVisible
      draft.navigateFromBot = payload?.navigationPath
      break
    }
    case Actions.PAYMENT_SUCCESS:
    case Actions.NAVIGATION_FROM_BOT: {
      draft.shouldDisplayTerminateBotAlert = false
      draft.navigateFromBot = routes.ROOT
      break
    }
    case Actions.TERMINATE_RISK_ASSESSMENT_POPUP: {
      draft.shouldDisplayTerminateRiskAssessmentAlert = payload?.isVisible
      break
    }
    case Actions.INITIATE_CONNECTIVITY_TEST: {
      draft.isConnectivityTesting = true
      break
    }
    case Actions.END_CONNECTIVITY_TEST: {
      draft.isConnectivityTesting = false
      draft.isConnectivityTested = true
      break
    }
    case Actions.ASK_TO_START_CLINIC: {
      draft.promptClinic = payload
      break
    }
    case Actions.START_CLINIC_ABORTED: {
      draft.promptClinic = null
      break
    }
    case Actions.SCHEDULE_PCP: {
      draft.isPCPFlow = { designated: true }
      draft.selectedService = clinicTypes.PRIMARY
      break
    }
    case Actions.SCHEDULE_ANY_PCP: {
      draft.isPCPFlow = { designated: false }
      draft.selectedService = clinicTypes.PRIMARY
      break
    }
    case Actions.LOCATION_CHANGED: {
      const path = payload?.location?.pathname
      // init selectedService and followup flags when navigating home
      if (
        path === routes.ROOT ||
        path === routes.SPECIALITY_SERVICES ||
        path === routes.BEFORE_VISIT
      ) {
        if (path === routes.ROOT || path === routes.SPECIALITY_SERVICES) {
          draft.isHTNFollowUp = false
          draft.isMHFollowUp = false
          draft.isDMFollowUp = false
          draft.isPrimaryHMOFollowUp = false
          draft.selectedService = null
          draft.hmoSelectedIntent = []
        }
        // needs to clean those flags also when navigating to before visit
        draft.isRescheduleFlow = false
        draft.isPCPFlow = null
        draft.isAfterConcent = false
      }
      draft.isTechnicalIssues = false
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    case Actions.RISK_ASSESMENT_BOT_ENDED: {
      draft.isCompleteRiskAssessmentDialogVisible = true
      break
    }
    case Actions.RISK_ASSESMENT_BOT_COMPLETED_CLOSED: {
      draft.isCompleteRiskAssessmentDialogVisible = false
      break
    }
    case Actions.HMO_BOT_STARTED: {
      draft.hmoSelectedIntent = payload?.intent || []
      draft.selectedService = payload?.isMentalHealth
        ? clinicTypes.MENTAL
        : clinicTypes.PRIMARY
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
